exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".idcard_wrap[data-v-731dd4d6]{border:1px solid #eeeeee}.idcard_wrap>div[data-v-731dd4d6]:first-child{border-right:1px solid #eeeeee}.img_header[data-v-731dd4d6]{height:40px;line-height:40px;background:#f5f5f5;color:#666666;font-size:16px}.img_wrap[data-v-731dd4d6]{width:250px;height:150px;margin:20px auto;background-color:#8f8f8f}.img_footer[data-v-731dd4d6]{height:40px;line-height:40px;border-top:1px solid #eeeeee}\n", ""]);

// exports
